module.exports = __webpack_public_path__ + "img/fig_6.b1e61e2e.svg";